"use strict";

exports.__esModule = true;
exports.MTCDataTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _MTCDataTableElement = require("./MTCDataTableElement");
var _MTCDataTableFields = require("./MTCDataTableFields");
var _MTCDataTableThumbnail = require("./MTCDataTableThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MTCDataTableWidget = exports.MTCDataTableWidget = {
  name: "MTCDataTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MTCDataTableWidget.label",
    defaultMessage: "MTC Data Table"
  }),
  icon: "th-list",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MTCDataTable",
      props: Object.assign({
        width: 512,
        height: 512
      }, props, {
        pageSizes: [25, 50, 100, 250]
      }),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_MTCDataTableElement.MTCDataTableElement),
    Fields: _MTCDataTableFields.MTCDataTableFields,
    Thumbnail: _MTCDataTableThumbnail.MTCDataTableThumbnail
  }
};